import DownloadListIcon from "./icons/DownloadListIcon";

export default function ButtonDownload(props: {
  onClick: () => void;
  isDisabled?: boolean;
}) {
  return (
    <button
      onClick={props.onClick}
      type="button"
      disabled={props.isDisabled}
      className="btn btn--action c-download-button"
      aria-label="Hent liste til excel"
    >
      Hent <DownloadListIcon width={19} />
    </button>
  );
}
